import type { LanguageCode, LocalizedText } from './types'

export const lt = (nl: string, en: string): LocalizedText => ({ nl, en })

export function pickLocalized(
  text: LocalizedText,
  lang: LanguageCode,
): string {
  return lang === 'en' ? text.en : text.nl
}

const MAX_BIO_UNWRAP = 8

/** Parse a string if it is JSON-encoded LocalizedText (unwrap DB/sync double-encoding). */
function tryParseLocalizedJson(s: string): LocalizedText | null {
  const t = s.trim()
  if (!t.startsWith('{')) return null
  try {
    const parsed = JSON.parse(t) as unknown
    if (!parsed || typeof parsed !== 'object') return null
    const o = parsed as Record<string, unknown>
    if (typeof o.nl !== 'string' || typeof o.en !== 'string') return null
    return { nl: o.nl, en: o.en }
  } catch {
    return null
  }
}

/** Normalize legacy string bios or partial JSON from sync into LocalizedText */
export function normalizeLocalizedBio(
  raw: unknown,
  fallback: LocalizedText,
): LocalizedText {
  let current: unknown = raw
  for (let i = 0; i < MAX_BIO_UNWRAP; i++) {
    if (typeof current === 'string') {
      const parsed = tryParseLocalizedJson(current)
      if (parsed) {
        current = parsed
        continue
      }
      return lt(current, current)
    }

    if (
      current &&
      typeof current === 'object' &&
      'nl' in current &&
      'en' in current
    ) {
      const o = current as Record<string, unknown>
      if (typeof o.nl === 'string' && typeof o.en === 'string') {
        const inner =
          tryParseLocalizedJson(o.nl) ?? tryParseLocalizedJson(o.en)
        if (inner) {
          current = inner
          continue
        }
        return { nl: o.nl, en: o.en }
      }
    }

    break
  }

  return fallback
}
